import i18next, { type Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import auditionForm from '../src/locales/ja/auditionForm.json';
import auditionForm_en from '../src/locales/en/auditionForm.json';
import message from '../src/locales/ja/message.json';
import message_en from '../src/locales/en/message.json';
import auditionInfo from '../src/locales/ja/auditionInfo.json';
import auditionInfo_en from '../src/locales/en/auditionInfo.json';
import mypage from '../src/locales/ja/mypage.json';
import mypage_en from '../src/locales/en/mypage.json';
import commons from '../src/locales/ja/commons.json';
import commons_en from '../src/locales/en/commons.json';
import recruitingAuditions from '../src/locales/ja/recruitingAuditions.json';
import recruitingAuditions_en from '../src/locales/en/recruitingAuditions.json';
import userEditDelete from '../src/locales/ja/userEditDelete.json';
import userEditDelete_en from '../src/locales/en/userEditDelete.json';
import loginError from '../src/locales/ja/loginError.json';
import loginError_en from '../src/locales/en/loginError.json';
import inquiry from '../src/locales/ja/inquiry.json';
import inquiry_en from '../src/locales/en/inquiry.json';
import consent from '../src/locales/ja/consent.json';
import consent_en from '../src/locales/en/consent.json';
import forgetUserId from '../src/locales/ja/forgetUserId.json';
import forgetUserId_en from '../src/locales/en/forgetUserId.json';
import contentsHandler from '../src/locales/ja/contents-handler.json';
import contentsHandler_en from '../src/locales/en/contents-handler.json';
import aboutMfaCodeSending from '../src/locales/ja/aboutMfaCodeSending.json';
import aboutMfaCodeSending_en from '../src/locales/en/aboutMfaCodeSending.json';

const ENTRY_HOST = process.env.REACT_APP_ENTRY_HOST;

export const defaultNS = 'auditionDetail';
export const resources = {
  ja: {
    auditionForm,
    message,
    auditionInfo,
    mypage,
    commons,
    recruitingAuditions,
    userEditDelete,
    loginError,
    inquiry,
    consent,
    forgetUserId,
    contentsHandler,
    aboutMfaCodeSending,
  },
  en: {
    auditionForm: auditionForm_en,
    message: message_en,
    auditionInfo: auditionInfo_en,
    mypage: mypage_en,
    commons: commons_en,
    recruitingAuditions: recruitingAuditions_en,
    userEditDelete: userEditDelete_en,
    loginError: loginError_en,
    inquiry: inquiry_en,
    consent: consent_en,
    forgetUserId: forgetUserId_en,
    contentsHandler: contentsHandler_en,
    aboutMfaCodeSending: aboutMfaCodeSending_en,
  },
} as const satisfies Resource;

export type Lang = 'ja' | 'en';
// const browserLang = navigator.language.slice(0, 2);
export const defaultLng: Lang = ENTRY_HOST === window.location.origin ? 'ja' : 'en';

i18next.use(initReactI18next).init({
  lng: defaultLng,
  debug: true,
  resources,
  defaultNS,
});

i18next
  .use(initReactI18next)
  .init({
    lng: defaultLng,
    debug: true,
    resources,
    defaultNS,
  })
  .then(() => {
    document.documentElement.lang = i18next.language;
    i18next.on('languageChanged', (lang: string) => {
      document.documentElement.lang = lang;
    });
  });
